import {useParams} from "react-router-dom";
import {Button, Flex} from "antd";
import {PageTitle} from "../../components/Common/PageTitle/PageTitle";
import {Paths} from "../../models/Paths";
import {DiscountCodeHeader} from "../../components/Info/DiscountCodeHeader/DiscountCodeHeader";
import {AgreementDetail} from "../../components/Info/AgreementDetail/AgreementDetail";
import "./Discount.css"
import React, {useEffect, useState} from "react";
import {Voucher, VoucherDetail} from "../../models/Info/voucher.model";
import {InformationService} from "../../services/InformationService";
import {isNil} from "lodash";
import DOMPurify from "dompurify";
import {AuthService} from "../../services/AuthService";
import {FileAddOutlined} from "@ant-design/icons";
import {useModal} from "../../utils/modals";
import {BasicFormMethod, BasicFormModal} from "../../components/Common/BasicComponents/BasicFormModal";
import {InsuranceProviderEclaim} from "../../models/InsuranceProvider";
import {AdminHttpService} from "../../services/Http/SearchTableService";
import {FilterString} from "../../components/Common/BasicComponents/filters/FilterString";
import {FilterTextEditor} from "../../components/Common/BasicComponents/filters/FilterTextEditor";
import {FilterNumber} from "../../components/Common/BasicComponents/filters/FilterNumber";

export function Discount() {
    let {id} = useParams();
    const [voucherDetails, setVoucherDetails] = useState<Array<VoucherDetail>>([]);
    const [discountsDetails, setDiscountsDetails] = useState<string>("");
    const [voucher, setVoucher] = useState<Voucher>()
    const {
        isOpen: isCreateFormModalOpen,
        open: openCreateFormModal,
        close: closeCreateFormModal
    } = useModal();

    function getSanitizedText(text:string){
        if(isNil(text) === false) {
            // @ts-ignore
            return DOMPurify.sanitize(text);
        }
        return ""
    }
    useEffect(() => {
        getDiscountInfo();

    }, [])

    const getDiscountInfo = () => {
        if (!id) return;
        InformationService.getVoucherDetailList(id)
            .then((res) => {
                setVoucherDetails(res.discounts);
                setVoucher(res)
                setDiscountsDetails(getSanitizedText(res.discountsInfo))
            })
    }

    const renderVoucherDetails = () => {
        const voucherDetailList = voucherDetails.map((voucherDetail) =>
            <li key={voucherDetail.id} className={"voucher-detail-list-element"}>
                <AgreementDetail agreementDetail={voucherDetail} />
            </li>
        )
        return <ul className={"voucher-detail-list"}>{voucherDetailList}</ul>
    }

    const formInputFields =[
        <FilterString dataKey={"title"} label={"Titolo"} required={true} ></FilterString>,
        <FilterNumber dataKey={"voucherId"} label={"Convenzione"} required={true} disabled={true} defaultValue={voucher ? voucher.id : undefined}></FilterNumber>,
        <FilterTextEditor  dataKey={"text"} label={"Testo"} containerProps={{style:{height:'200px'}}} ></FilterTextEditor>,
    ]

    return (
        <>
            <Flex vertical >
                <Flex align={"center"} justify={"space-between"}>
                    <PageTitle title={"Scontistica"} backTo={Paths.INFO} />

                    {AuthService.isAdmin() ?
                        <Button icon={<FileAddOutlined/>} type={"primary"} key="download"
                                onClick={() => openCreateFormModal()}>
                            Aggiungi Scontistica
                        </Button> : undefined}
                </Flex>
                <Flex vertical className={"discount-content"} gap={"middle"}>
                    { voucher !== null && <DiscountCodeHeader organizationId={voucher?.insuranceProviderId} discountCode={voucher?.code} /> }
                    { discountsDetails === '' || <span style={{textWrap: 'wrap'}} dangerouslySetInnerHTML={{__html: discountsDetails}}/>}
                    {renderVoucherDetails()}
                </Flex>

                {isCreateFormModalOpen &&
                    <BasicFormModal<InsuranceProviderEclaim> inputFields={formInputFields} title={"Aggiungi scontistica"}
                                                             urlPath={AdminHttpService.URL_ADMIN_VOUCHERS_DISCOUNTS} method={BasicFormMethod.CREATE}
                                                             isOpen={isCreateFormModalOpen} onCancel={closeCreateFormModal}
                                                             onOk={()=>{
                                                                 closeCreateFormModal();
                                                                 getDiscountInfo();
                                                             }}
                                                              ></BasicFormModal>}
            </Flex>
        </>
    )
}